// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"edddd170","703":"10e7c0e4","787":"bc19231f"}[chunkId] + ".chunk.js";
};